/**
 * Utilidades para el módulo de Técnicos
 */

/**
 * Extrae y formatea el mensaje de error de un objeto de error de Axios
 */
export const parseError = (err) => {
  if (!err) return "Error desconocido";
  if (err.response && err.response.data) {
    // Try common fields
    return (
      err.response.data.message ||
      err.response.data.error ||
      JSON.stringify(err.response.data)
    );
  }
  return err.message || String(err);
};

